import * as React from 'react';

import { ChatRoomType, ChatPlugin } from '@common/react/components/Chat/Chat';
import VideoChatButton, { LastMessage } from '@common/react/components/UI/VideoChat/VideoChatButton';

const Message = ({
	message, withRemoteId, lastVideoCallId, contacts,
}) => <>
	<div className="chat-message-list-component__item-call-button">
		<VideoChatButton
			chatId={message.chatId}
			roomId={message.text}
			notifyUserIds={contacts.map((item) => item.id)}
			roomName={withRemoteId ? message.chat?.name ?? 'Unknown' : message.text.split('_')[1]}
			disabled={lastVideoCallId !== message.id}
			roomType={message.chatRoomType}
		/>
	</div>
</>;

const messagesHeaderAction = ({ withRemoteId, currentChat, user }) => {
	const userCall = currentChat.contacts.find((item) => (withRemoteId ? item.remoteId === null : item.id !== user.id));
	return <VideoChatButton
		roomType={ChatRoomType.Audio}
		roomId={`${currentChat.id}_${currentChat.name}`}
		roomName={`${userCall?.firstName} ${userCall?.lastName}`}
		chatId={currentChat.id}
		avatar={userCall?.avatar}
		notifyUserIds={withRemoteId ? [user.id, userCall.id] : currentChat.contactsIds}
		className="btn btn-sm btn-primary pull-right audio-call"
		title={withRemoteId ? 'Audio call to the patient' : 'Audio Call'}
	/>;
};

export const VoiceCallPlugin: ChatPlugin = {
	message: {
		render: Message,
		lastMessage: LastMessage,
	},
	messagesHeaderAction,
	options: {
		requestType: 'videoChat',
	},
};
